
import React, { useState,useEffect } from "react";// react-router-dom components
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Switch from "@mui/material/Switch";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { authLogin,authApprovalStatus } from '../../../assets/globalAPI/GlobalApi';
// Images
import curved9 from "assets/images/anmolLoginLogo.jpg";
import ifblogo from "assets/images/logo-ct.png";
import { userLogin } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";

function SignIn() {
  const [userid, setUserId] = useState('');
  const [variant, setVariant] = useState('');
  const [password, setPassword] = useState('');
  const [isActive,setIsActive]= useState(false);
  const toastId = React.useRef(null);
  const [rememberMe, setRememberMe] = useState(true);
  const [loader,setLoader] = useState(false);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const sampleUsers = [
    {
      userId: "ARSUKRIT",
      password: "anmol@1234", 
      level: "app-1",
      name: "Sukrit Chakraborty"
    },
    {
      userId: "ARSUBRATA",
      password: "anmol@1234",
      level: "app-2",
      name: "Subrata Saha"
    },
    {
      userId: "ARRONI",
      password: "anmol@1234",
      level: "app-3",
      name: "Roni Modak"
    },
    {
      userId: "ARKARTICK",
      password: "anmol@1234",
      level: "department",
      name: "Kartick Dutta"
    },
    {
      userId: "ARSUMANTA",
      password: "anmol@1234",
      level: "accounts",
      name: "Sumanta Roy"
    },
    {
      userId: "ARPRITAM",
      password: "anmol@1234",
      level: "IT",
      name: "Pritam Manna"
    },
    {
      userId: "ANPUJA",
      password: "anmol@1234",
      level: "MDM",
      name: "Puja Lye"
    },
    {
      userId: "ARUDIT",
      password: "anmol@1234",
      level: "approver-1",
      name: "Udit Seth"
    },
  ];
  

  useEffect(() => {
    let username = searchParams.get('username'); 
    let password = searchParams.get('password'); 
    let mode = searchParams.get('mode'); 
    let page = searchParams.get('page');
    let customerid = searchParams.get('customerid');  

    let userDetails= localStorage.getItem("userdetails");
    if(userDetails){
      let userData= JSON.parse(userDetails);
      if(userData){
        navigate("/dashboard");
      }
    }
  },[]);
  const onChangeEmail = async (e) => {
    setUserId(e.target.value);
};
const onChangePassword = async (e) => {
  setPassword(e.target.value);
};
  // const handleSubmit = async event => {  
  //   event.preventDefault();
    
  //   if(userid!='' && password!='')
  //   {
  //     const data = {
  //     "action": 'userLogin',	
  //     "userid": userid,
  //     "password": password,
  //   };
  //   //console.log(data);
  //   authLogin(JSON.stringify(data)).then(function(response) {
  //       var res = response.data;
  //       //console.log(res);
  //         if(res.status=='true' && res.code=='200')
  //         {
  //           localStorage.setItem('userid_details', JSON.stringify({userid:res.userid,user_type:res.user_type,id:res.id,email:res.email,name:res.name, user_variant: variant})); 
  //           navigate('/dashboard');
  //         }else{
  //       if(! toast.isActive(toastId.current)) {
  //       toastId.current = toast.warning(res.message)  
  //     }
  //       }
  //       }.bind(this)
  //   )
  //   .catch(function(error) {
  //     setLoader(false)
  //     console.log(error);
    
  //   });     
  //   }else{
      
  //     if(! toast.isActive(toastId.current)) {
  //       toastId.current = toast.warning("please fill up the required field")
  
  //     }
  
  //   }
  
  // }

  const handleSubmit = async (event) => {  
    event.preventDefault();
    setIsActive(true)

    if(userid==="" || password===""){
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Please Fill the Required Fields",{
          className: "small-toast"
        });
      }
      setIsActive(false)
      return;
    }

    const body={
      userId: userid,
      userPassword: password
    }

    try{
      const response= await userLogin(body);
      const res= response.data;
      console.log("So here is login response");
      if(res.status){
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.success(res.message,{
            className: "small-toast"
          });
        }
        console.log("here is the login success response>> ", res);
        localStorage.setItem("userdetails", JSON.stringify(res.userdata));
        localStorage.setItem("sessionCode", JSON.stringify(res.sessionCode));
        localStorage.setItem("userRoles", JSON.stringify(res.role))
        localStorage.setItem("userToken", res.token)
        setIsActive(false)
        navigate("/dashboard");
      }else{
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error(res.message,{
            className: "small-toast"
          });
        }
        setIsActive(false)
        return
      }
    }catch(error){
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Login Error",{
          className: "small-toast"
        });
      }
      console.log("error in login>> ", error)
      setIsActive(false)
    }
   
    // if (userid.trim() !== "" && password.trim() !== "") {
    //   const user = sampleUsers.find(
    //     (user) => user.userId === userid && user.password === password
    //   );

    //   if (user) {
    //     localStorage.setItem(
    //       "userDetails",
    //       JSON.stringify({ userId: user.userId, level: user.level, name: user.name })
    //     );
    //     navigate("/dashboard");
    //   } else {
    //     if (!toast.isActive(toastId.current)) {
    //       toastId.current = toast.error("Invalid credentials");
    //     }
    //   }
    // } else {
    //   if (!toast.isActive(toastId.current)) {
    //     toastId.current = toast.warning("Please fill up the required fields");
    //   }
    // }
  
  }
 
  return (
    <CoverLayout
      title="CRM/MDM Portal"
      description=""
      image={curved9}
    >
     
       <ToastContainer />
       <SimpleBackdrop openLoader={isActive}/>
       
      <SoftBox onSubmit={handleSubmit} component="form" role="form">
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              User ID
            </SoftTypography>
          </SoftBox>
          <SoftInput type="text" placeholder="User ID" value={userid} onChange={onChangeEmail} />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Password
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Password" value={password} onChange = {onChangePassword} />
        </SoftBox>
        {/* <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Choose variant
            </SoftTypography>
          </SoftBox>
          <SoftSelect
            name="variant"
            id="variant"
            onChange={(e)=>setVariant(e.value)}
            options={[
              { value: "vendor", label: "Vendor Creation(SAP ECC)" },
              { value: "bp", label: "Business Partner(SAP S4 HANA)" }
            ]}
                              />
        </SoftBox> */}
        {/* <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Remember me
          </SoftTypography>
        </SoftBox> */}
        <SoftBox mt={4} mb={1}>
          <SoftButton variant="gradient" color="error" fullWidth type="submit">
            sign in
          </SoftButton>
          <a href="/authentication/forgot-password" target="_self" rel="noopener noreferrer" style={{fontSize:"13px"}}>Forgot Password?</a>
        </SoftBox>
        {/* <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t have an account?{" "}
            <SoftTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Sign up
            </SoftTypography>
          </SoftTypography>
        </SoftBox> */}
 
        
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
